// extracted by mini-css-extract-plugin
export var displayNone = "_pi-6";
export var imgContainer = "_pi-2";
export var overflowHidden = "_pi-3";
export var productInfoCardButtonContainer = "_pi-5";
export var productTitleText = "_pi-4";
export var rightArrow = "_pi-1";
export var rightArrowContainer = "_pi-0";